import { combineReducers } from 'redux';
import {
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CATEGORY,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_INGREDIENTS,
  INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE,
  INGREDIENT_CATEGORY_HIDE_ASSIGN_TO_INGREDIENT_MODAL,
  INGREDIENT_CATEGORY_HIDE_DELETE_MODAL,
  INGREDIENT_CATEGORY_HIDE_RIGHT_COLUMN,
  INGREDIENT_CATEGORY_SET_CATEGORIES,
  INGREDIENT_CATEGORY_SET_CATEGORY_DETAIL,
  INGREDIENT_CATEGORY_SET_CURRENT_PAGE,
  INGREDIENT_CATEGORY_SET_IS_SUBMITTING,
  INGREDIENT_CATEGORY_SET_OUTLETS,
  INGREDIENT_CATEGORY_SET_TOTAL_PAGE,
  INGREDIENT_CATEGORY_SHOW_ASSIGN_TO_INGREDIENT_MODAL,
  INGREDIENT_CATEGORY_SHOW_DELETE_MODAL,
  INGREDIENT_CATEGORY_SHOW_RIGHT_COLUMN,
} from 'actions/ingredients/category/constants';
import createReducer from 'utils/createReducer';

const ingredientCategory = createReducer(null, {
  [INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CATEGORY]: (
    draft,
    { payload }
  ) => payload.category,
});

const ingredientCurrentPage = createReducer(0, {
  [INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE]: (
    draft,
    { payload }
  ) => payload.currentPage,
});

const ingredientIngredients = createReducer([], {
  [INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_INGREDIENTS]: (
    draft,
    { payload }
  ) => payload.ingredients,
});

const ingredientTotalPage = createReducer(0, {
  [INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE]: (
    draft,
    { payload }
  ) => payload.totalPage,
});

const assignToIngredients = combineReducers({
  category: ingredientCategory,
  currentPage: ingredientCurrentPage,
  ingredients: ingredientIngredients,
  totalPage: ingredientTotalPage,
});

const categories = createReducer([], {
  [INGREDIENT_CATEGORY_SET_CATEGORIES]: (draft, { payload }) =>
    payload.categories,
});

const categoryDetail = createReducer(null, {
  [INGREDIENT_CATEGORY_SET_CATEGORY_DETAIL]: (draft, { payload }) =>
    payload.category,
});

// FIXME wrong default ypte
const currentPage = createReducer(null, {
  [INGREDIENT_CATEGORY_SET_CURRENT_PAGE]: (draft, { payload }) => payload.page,
});

const isSubmitting = createReducer(false, {
  [INGREDIENT_CATEGORY_SET_IS_SUBMITTING]: (draft, { payload }) =>
    payload.isSubmitting,
});

const openRightColumn = createReducer(false, {});

const outlets = createReducer([], {
  [INGREDIENT_CATEGORY_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const showAssignToIngredientModal = createReducer(false, {
  [INGREDIENT_CATEGORY_SHOW_ASSIGN_TO_INGREDIENT_MODAL]: () => true,
  [INGREDIENT_CATEGORY_HIDE_ASSIGN_TO_INGREDIENT_MODAL]: () => false,
});

const showDeleteModal = createReducer(false, {
  [INGREDIENT_CATEGORY_SHOW_DELETE_MODAL]: () => true,
  [INGREDIENT_CATEGORY_HIDE_DELETE_MODAL]: () => false,
});

const showRightColumn = createReducer(false, {
  [INGREDIENT_CATEGORY_SHOW_RIGHT_COLUMN]: () => true,
  [INGREDIENT_CATEGORY_HIDE_RIGHT_COLUMN]: () => false,
});

// FIXME wrong default ypte
const totalPage = createReducer(null, {
  [INGREDIENT_CATEGORY_SET_TOTAL_PAGE]: (draft, { payload }) => payload.page,
});

export default combineReducers({
  assignToIngredients,
  categories,
  categoryDetail,
  currentPage,
  isSubmitting,
  openRightColumn,
  outlets,
  showAssignToIngredientModal,
  showDeleteModal,
  showRightColumn,
  totalPage,
});
